






import { Mixins, Prop, Component } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { BreadcrumbData } from '@/entities/breadcrumb/Breadcrumb';
import { GoogleService } from '@/services/google-service';

@Component
export default class GoogleMarkupData extends Mixins(BaseMixin) {
    @Prop()
    private readonly data!: string;

    private readonly service: GoogleService = new GoogleService();

    get content(): string {
        const data: BreadcrumbData = JSON.parse(this.data);

        data.items.forEach((item) => (item.url = `${window.location.origin}${item.url}`));

        const markupData = this.service.generateBreadcrumbMarkupData(data);
        return this.service.stringifyBreadcrumbMarkupData(markupData);
    }
}
